import { FC } from 'react';
import { RemoveAlertDialog, useBoolean } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import useFinishBasket from '@flows/src/hooks/useFinishBasket';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  sessionId: string;
}

const FinishBasketModal: FC<Props> = ({ isOpen, onClose, sessionId }) => {
  const { t } = useTranslation();
  const [isCreating, setIsCreating] = useBoolean(false);
  const { handleFinish } = useFinishBasket(sessionId, setIsCreating);

  return (
    <RemoveAlertDialog
      isOpen={isOpen}
      onClose={onClose}
      title={t('FLOWS_PRODUCT-BASKET_ACTION-FINISH_MODAL_TITLE')}
      description={t('FLOWS_PRODUCT-BASKET_ACTION-FINISH_MODAL_DESCRIPTION')}
      variant="primary"
      confirmButtonText={t('FLOWS_PRODUCT-BASKET_ACTION-FINISH_MODAL_ACTION')}
      isLoading={isCreating}
      onConfirm={handleFinish}
    />
  );
};

export default FinishBasketModal;
